import React from 'react';
import { ReadMoreStyles as S } from './ReadMore.styles';
import CtaLink from '../CtaLink/CtaLink';
const ReadMore = ({ onClick, expanded }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.ReadMore, { "data-expanded": expanded },
            React.createElement(CtaLink, { as: "button", onClick: () => {
                    onClick(!expanded);
                }, icon: "chevron-down" },
                "Read ",
                expanded ? 'Less' : 'More'))));
};
export default ReadMore;
